import { useCallback, useEffect, useRef, useState } from 'react';
import { apiClient } from '../../../shared/api/apiClient';
import { useToast } from '../../../shared/ui/Toast/ToastProvider';

// Filtro activo de la bandeja de WhatsApp, espejado en `/api/customs` (integración main→dev,
// catch-up F — B2 lo había diferido). Escritura optimista + fire-and-forget, mismo patrón que
// `DappViewer` (el componente hermano de este directorio) y `useWorkframePref`.
export function useWhatsActiveFilter(userId) {
    const [activeFilter, setActiveFilter] = useState('Todos');
    const hydratedRef = useRef(false);
    const toast = useToast();

    useEffect(() => {
        if (hydratedRef.current || !userId) return;
        hydratedRef.current = true;
        apiClient.get(`/api/customs/${userId}/whats_active_filter`)
            .then((data) => {
                if (data?.success && data.value) setActiveFilter(data.value);
            })
            .catch(() => {});
    }, [userId]);

    const changeFilter = useCallback((filter) => {
        setActiveFilter(filter);
        if (userId) {
            apiClient.post('/api/customs', { userId, key: 'whats_active_filter', value: filter })
                .then(() => toast.success("Filtro guardado"))
                .catch(() => toast.error("Error al guardar filtro"));
        } else {
            toast.info("Solo filtro local");
        }
    }, [userId, toast]);

    return { activeFilter, changeFilter };
}
